import { h, Component } from "preact";
import { css } from "emotion";
import { hexToRgba } from "../../utils/Format";
const styles = {
  link: css`
    text-decoration: none !important;
    color: inherit !important;
  `
};
/**
 * Display tiles view of events
 *
 * @param {*} props
 * @returns
 */
const EventTilesView = props => {
  const { event, noRightMargin, showPrice, eventListingLayout, theme } = props;
  const eventLink = `/${event.slug}`;
  let bannerImage =
    event.featureImage && event.featureImage.url
      ? event.featureImage.url
      : null;
  bannerImage =
    event.socialImage && event.socialImage.url
      ? event.socialImage.url
      : bannerImage;
  bannerImage =
    event.bannerImage && event.bannerImage.url
      ? event.bannerImage.url
      : bannerImage;
  const eventTitle =
    eventListingLayout === "eventTitle"
      ? event.name
      : event.location.titleLocation;
  const eventInfo =
    eventListingLayout === "eventTitle"
      ? event.location.titleLocation
      : event.name;

  const customStyles = {
    wrapper: css`
      margin-left: auto;
      width: 320px;
      height: ${showPrice ? "308px" : "288px"};
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: ${noRightMargin ? "0px" : "20px"};
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 1px 8px 0 rgba(32, 7, 64, 0.13);
      @media (max-width: 900px) {
        margin: 6px;
      }
      @media (max-width: 600px) {
        width: auto;
        margin-top: 12px;
        margin-left: 1px;
        margin-right: 1px;
        max-width: 100%;
        height: 100%;
      }
    `,
    image: css`
      max-width: 320px;
      width: 100%;
      padding-top: 50%;
      background: url(${bannerImage}) center center / cover no-repeat
        rgb(238, 238, 238);
      @media (max-width: 600px) {
        width: 100%;
        max-width: 100%;
        border-radius: 0px;
      }
    `,
    contentsRow: css`
      width: 100%;
      max-width: 320px;
      padding: 16px 12px;
      background: ${hexToRgba(
        theme.eventCardBackgroundColor,
        theme.cardAndBarOpacity
      )};
      height: 100%;
      @media (max-width: 600px) {
        max-width: 100%;
      }
    `,
    title: css`
      font-size: 18px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 6px;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? theme.cardTitleColor
        : "#ffffff"};
    `,
    contents: css`
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: ${theme.eventCardBackgroundColor === "#ffffff"
        ? theme.cardTextColor
        : "#ffffff"};
    `
  };

  return (
    <div>
      <a href={eventLink} className={styles.link} aria-label="Get Tickets">
        <div className={customStyles.wrapper}>
          <div className={customStyles.image} />
          <div className={customStyles.contentsRow}>
            <div className={customStyles.title}>{eventTitle}</div>
            <div className={customStyles.contents}>
              {event.dates[0].display.combined}
            </div>
            <div className={customStyles.contents}>{eventInfo}</div>
            {showPrice ? (
              <div className={customStyles.contents}>
                {event.ticketsPriceStr}
              </div>
            ) : null}
          </div>
        </div>
      </a>
    </div>
  );
};

export default EventTilesView;



// WEBPACK FOOTER //
// ./routes/tours/EventTilesView.js